import { MetroRecruitersState, ReadMetroRecruitersActionTypes, READ_METRO_RECRUITERS_DATA_REQUEST, READ_METRO_RECRUITERS_DATA_SUCCESS, READ_METRO_RECRUITERS_DATA_FAILURE } from "store/reducers/types/dashboard/metroRecruiters";

const defaultState: MetroRecruitersState = {
  isLoading: false,
  errorMessage: ""
};

export default function metroRecruiters(state = defaultState, action: ReadMetroRecruitersActionTypes): MetroRecruitersState {
  switch (action.type) {
    case READ_METRO_RECRUITERS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_METRO_RECRUITERS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_METRO_RECRUITERS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
